import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';

interface AddGatewayState {
  name: string | undefined,
  lat: number | undefined,
  long: number | undefined,
  deviceId: string | undefined,
  matchesExistingDevice: boolean,
  version: number | undefined
}

const initialState: AddGatewayState = {
  name: undefined,
  lat: undefined,
  long: undefined,
  deviceId: undefined,
  matchesExistingDevice: false,
  version: undefined
};

export const AddGatewayStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setName(name: string | undefined) {
      patchState(store, {name});
    },
    setLat(lat: number | undefined) {
      patchState(store, {lat});
    },
    setLong(long: number | undefined) {
      patchState(store, {long});
    },
    setDeviceId(deviceId: string | undefined) {
      patchState(store, {deviceId});
    },
    setMatchesExistingDevice(matchesExistingDevice: boolean) {
      patchState(store, {matchesExistingDevice});
    },
    setVersion(version: number | undefined) {
      patchState(store, {version});
    },
    reset() {
      patchState(store, initialState);
    }
  })
));
